var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background"},[_c('shape-left',{staticClass:"shape-left"}),_c('shape-right',{staticClass:"shape-right"}),_c('div',{staticClass:"first-overlay"}),_c('div',{staticClass:"second-overlay"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }